import React from 'react'
import { Row, Col, Form } from "react-bootstrap";
import { Controller } from 'react-hook-form';
import st from "../../style.module.scss";
import Select from "react-select";
import NestedRadioOptions from './NestedRadioOptions';
import NestedDropDownOptions from './NestedDropDownOptions';

function QuestionBody(
   { errors,
    register,
    watch,
    control,
    getValues,
    index,
    setValue}
) {

    const options = [
        { value: "text", label: "Text" },
        // { value: "multiple-choice", label: "Multiple choice" },
        { value: "single-choice", label: "Single Select" },
    ];

    const restDataValue = (data, index) => {
        if (getValues()?.form[index]?.question) {
            {
                if (data?.value === "text") {
                    setValue(`form.${index}`, {
                        ...getValues()?.form[index],
                        score: getValues()?.form[index]?.score,
                    });
                } else {
                    setValue(`form.${index}`, {
                        ...getValues()?.form[index],
                        nestedOptions: getValues()?.form[index]?.nestedOptions?.map(
                            ({ name, score }) => ({
                                Option: name,
                                score: score,
                            })
                        ),
                    });
                }
            }
        }
    };

    return (
        <>
            <Row>
                <Col lg={7} md={7}>
                    <Form.Label htmlFor={`form.${index}.question`}>
                        Question
                    </Form.Label>
                    <Form.Group
                        className={`${st.formField} ${st.new_formFields}`}
                    >
                        <Form.Control
                            type="text"
                            placeholder="Question"
                            {...register(`form.${index}.question`, {
                                required: "Question is required",
                            })}
                            isInvalid={!!errors.form?.[0]?.question}
                        />
                        {errors.form?.[index]?.question?.message && (
                            <span className="text-danger">
                                This field is required
                            </span>
                        )}
                        <Form.Control.Feedback type="invalid">
                            {errors.form?.[index]?.question?.message}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col lg={4} md={4}>
                    <div className={`${st.react_select_drop}`}>
                        <Form.Label htmlFor={`form.${index}.fieldType`}>
                            Field Type
                        </Form.Label>
                        <Controller
                            name={`form.${index}.fieldType`}
                            control={control}
                            rules={{
                                required: "This field is required",
                            }}
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    isSearchable={false}
                                    className={`react-dropdown ${errors.form?.[index]?.fieldType
                                        ? "is-invalid"
                                        : ""
                                        }`}
                                    classNamePrefix="dropdown"
                                    options={options}
                                    isDisabled={
                                        watch(`form.${index}.fieldType`)?.value ===
                                        "number" ||
                                        watch(`form.${index}.fieldType`)?.value ===
                                        "decision-tree"
                                    }
                                    onChange={(event) => {
                                        field.onChange(event);
                                        restDataValue(event, index);
                                    }}
                                />
                            )}
                        />
                        {errors.form?.[index]?.fieldType && (
                            <div className="invalid-feedback d-block">
                                {errors.form?.[index]?.fieldType?.message}
                            </div>
                        )}
                    </div>
                </Col>
            </Row>

            {watch(`form.${index}.fieldType`)?.value === "text" && (
                <Col lg={4} md={4}>
                    <Form.Group
                        className={`${st.formField} ${st.new_formFields}`}
                    >
                        <Form.Control
                            type="number"
                            placeholder="Score"
                            {...register(`form.${index}.score`, {
                                required: "Score is required",
                            })}
                            isInvalid={!!errors.form?.[0]?.score}
                        />
                        {errors.form?.[index]?.score?.message && (
                            <span className="text-danger">
                                This field is required
                            </span>
                        )}
                        <Form.Control.Feedback type="invalid">
                            {errors.form?.[index]?.score?.message}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            )}

            {watch(`form.${index}.fieldType`)?.value ===
                "single-choice" && (
                    <Row>
                        <Col lg={7}>
                            <NestedRadioOptions
                                nestIndex={index}
                                {...{ control, register, errors, getValues }}
                            />
                        </Col>
                    </Row>
                )}

            {watch(`form.${index}.fieldType`)?.value ===
                "multiple-choice" && (
                    <Row>
                        <Col lg={7}>
                            <NestedDropDownOptions
                                nestIndex={index}
                                {...{ control, register }}
                            />
                        </Col>
                    </Row>
                )}
        </>
    )
}

export default QuestionBody